module.exports = __webpack_public_path__ + "static/media/customer.c0deedac.png";